<div
  class="rounded-4 p-2"
  [ngClass]="active ? 'border border-black bg-white' : 'background'"
  (click)="clickChangeStep()"
>
  <div class="d-flex align-items-center justify-content-between gap-2">
    <div class="d-flex gap-2 align-items-center">
      <span
        class="px-3 py-2 rounded-3 color-texto-principal"
        [ngClass]="{
          'color-texto-3': !active && !checked,
          background: active,
          'bg-white': !active
        }"
      >
        <b>{{ number }}</b>
      </span>
      @if (!active && !checked) {
        <span class="color-texto-3 disabled">
          <b>{{ title }}</b>
        </span>
      } @else {
        <a [class.stretched-link]="!blocked" class="text-decoration-none color-texto-principal">
          <b>{{ active ? 'Você está aqui' : title }}</b>
        </a>
      }
    </div>
    <div [ngClass]="checked ? 'd-block' : 'd-none'">
      <img src="/assets/img/icons/detalhes-do-pedido/vermelho/checked.svg" alt="" />
    </div>
  </div>
</div>
<div class="step-line" [ngClass]="checked ? 'd-block' : 'd-none'"></div>
